import { useState } from 'react';
import { ControlledField, SelectInputField } from 'remote/global';
import { UseFormReturn } from 'react-hook-form';
import { useOperatorsVehiclesAllQuery } from 'api/queries/operators';
import { useTranslation } from 'react-i18next';

function VehicleSelectField({
  form,
}: {
  form: UseFormReturn<any>; // TODO: FIX THIS TYPING
}) {
  const { t } = useTranslation();
  const { control } = form;
  // Only enable the query if it is focused
  const [isVehiclesAllQueryEnabled, setIsVehiclesAllQueryEnabled] = useState(false);
  const { data: allVehicles } = useOperatorsVehiclesAllQuery(isVehiclesAllQueryEnabled);

  const options =
    allVehicles?.map((vehicle) => ({
      label: `${vehicle.licensePlate} (${t('SchedulerView.attributes.numOfSeats', {
        seats: vehicle.seats,
      })})`,
      value: vehicle.licensePlate, // usually we would use id, but this endpoint wants licensePlate
      seats: vehicle.seats,
    })) ?? [];

  return (
    <ControlledField
      control={control}
      name='licensePlate'
      render={(renderProps) => {
        return (
          <SelectInputField
            {...renderProps}
            translationKey='licensePlateOptional'
            fieldProps={{
              onFocus: () => {
                if (!isVehiclesAllQueryEnabled) setIsVehiclesAllQueryEnabled(true);
              },
            }}
            options={options}
          />
        );
      }}
    />
  );
}

export default VehicleSelectField;
